
import { emptyArray } from "constants/emptyConst";
import { getOperationName } from "@apollo/client/utilities";
import { useQueryWithErrorHandling } from "customHooks/errorHandling";

export const useDictionary = (query, options = {}) => {
    const { data, loading } = useQueryWithErrorHandling(query, options);
    const operationName = getOperationName(query);
  
    const result = data?.[operationName] ?? emptyArray;
    return {
      data: result,
      loading
    };
  };
  